export default "/images/vendor/flag-icon-css/flags/1x1/et.svg?061591dd14f8c02c150f57d14cabd671";